import React from 'react';

import ProgressCircle from 'UI/ProgressCircle/ProgressCircle';

import defaultAvatar from 'assets/icons/skill_levels/beginner.png';
import defaultBadge from 'assets/icons/userTitle/beginner_badge_gray.svg';

import styles from './PlayerCard.module.scss';

const PlayerCard = ({
    level_progress,
	level,
    width,
    sreenWidth,
    imageSize,
    user_badge_width,
    user_badge_position,
    trailColor,
	colors
}) => {
    const style = { width: width };

    return (
        <section className={styles.user_card} style={style}>
            <div className={styles.circle_wrapper}>
                    <ProgressCircle
                        className={styles.circle}
                        percent={
                            level === 'master'
                                ? 100
                                : level_progress
                                ? level_progress
                                : 0
                        }
                        strokeWidth={1}
                        strokeColor={{ '0%': colors.color1, '100%': colors.color2 }}
                        trailWidth={1}
                        trailColor={trailColor ? trailColor : '#ffffff42'}
                        strokeLinecap="round"
                        gapDegree={sreenWidth > 1920 ? 18 : 28}
                        width={width}
                        gapPosition="top"
                        animate={true}
						timer={7}
                    />
                <div className={styles.user_avatar}>
                    {level ? (
                        <img
                            src={require(`assets/icons/skill_levels/${level}.png`)}
                            alt="user default"
                            style={{
                                width: imageSize,
                                height: imageSize,
                                borderRadius: '50%',
                            }}
                        />
                    ) : <img
							src={defaultAvatar}
							alt="user default"
							style={{
								width: imageSize,
								height: imageSize,
								borderRadius: '50%',
							}}
						/>}
                </div>
                {level ?
                    <div
                        className={styles.player_badge}
                        style={{ bottom: user_badge_position }}
                    >
                        <img src={require(`assets/icons/userTitle/${level}_badge.svg`)} style={{ height: user_badge_width }} alt="" />
                    </div> :
                    <div
                        className={styles.player_badge}
                        style={{ bottom: user_badge_position }}
                    >
                        <img src={defaultBadge} style={{ height: user_badge_width }} alt="" />
                    </div>
                }
            </div>
        </section>
    );
};

export default PlayerCard;
